import { render, staticRenderFns } from "./app-layout.vue?vue&type=template&id=ba9c82c6&scoped=true&"
import script from "./app-layout.vue?vue&type=script&lang=js&"
export * from "./app-layout.vue?vue&type=script&lang=js&"
import style0 from "./app-layout.vue?vue&type=style&index=0&id=ba9c82c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9c82c6",
  null
  
)

export default component.exports